import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const FundList = ({ funds }) => {
  return (
      <div className="fund-list">
        {funds.map((fund, index) => (
            <div key={index} className="fund-card">
              <div className="fund-info">
                <div className="fund-name">{fund.name}</div>
                <div className="fund-meta">
                  <FontAwesomeIcon icon="shield-alt" className="me-1" />
                  Risk: {fund.risk}/7
                  <span className="mx-2">•</span>
                  <FontAwesomeIcon icon="percentage" className="me-1" />
                  Charge: {fund.charge}
                </div>
              </div>
              <div className="fund-allocation">
                {fund.allocation?.toFixed(1) || 0}%
              </div>
            </div>
        ))}
      </div>
  );
};

export default FundList;